import React, { useEffect, useState }        from 'react';
import { connect }                           from 'react-redux';
import Grid                                  from '@mui/material/Grid';
import { useTranslation }                    from 'react-i18next';
import InputAdornment                        from '@mui/material/InputAdornment';
import IconButton                            from '@mui/material/IconButton';
import SearchIcon                            from '@mui/icons-material/Search';
import TextField                             from '@mui/material/TextField';
import ClearIcon                             from '@mui/icons-material/Clear';
import { useHistory, useLocation } from '../../../../utils/reactRouterCompatibility';
import queryString                           from 'query-string';
import {setAlbumsFilters, setAlbumsPaging}   from '../../../../../store/actions/discography/AlbumAction';

const Filters = ({ setAlbumsFilters, setAlbumsPaging, filters }) => {
	const { t } = useTranslation();

	const location = useLocation();
	let params = queryString.parse(location.search);
	const [search, setSearch] = useState(filters?.Name?.['$anywhere'] || params.s);


	const history = useHistory();

	const handleSearchChange = e => {
		if (e.key !== 'Enter')
			return;

		filterHandler();
	};

	const filterHandler = (clear = false) => {
		let params = queryString.parse(location.search);
		delete params.s;
		if (!clear && search && search.trim()) params.s = search;
		params.p = 1;
		history.push(location.pathname + '?' + queryString.stringify(params));
	};

	useEffect(() => {
		let params = queryString.parse(location.search);
		if ((!!params.s && filters?.Name?.['$anywhere'] !== params.s)) {
			setAlbumsFilters({ ...filters, Name: {'$anywhere':params.s} });
			setAlbumsPaging({ page_no: 1 });
			return;
		}

		if (!params.s) {
			let tmp = { ...filters };
			delete tmp.Name;
			setAlbumsFilters(tmp);
			setAlbumsPaging({ page_no: 1 });
		}
		// eslint-disable-next-line
	}, [location]);

	const clearFiltersHandler = () => {
		setSearch('');
		filterHandler(true);
	};

	useEffect(() => {
		return () => {
			setAlbumsFilters({});
		};
		// eslint-disable-next-line
	}, []);

	return (
        <Grid container item xs={12} spacing={3}>
            <Grid item xs={12}>
				<TextField
					fullWidth
					variant='outlined'
					value={search}
					onKeyPress={handleSearchChange}
					onChange={e => setSearch(e.target.value)}
					placeholder={t('placeholder_search_albums')}
					InputProps={
						{
							min: 0,
							endAdornment:
								(<InputAdornment position='end'>
									<IconButton
                                        aria-label={t('placeholder_search_albums')}
                                        onClick={() => filterHandler()}
                                        size="large">
										<SearchIcon/>

									</IconButton>
									{search && <IconButton
                                        aria-label={t('clear_filter_label')}
                                        onClick={clearFiltersHandler}
                                        size="large">
										<ClearIcon/>

									</IconButton>}
								</InputAdornment>)
						}
					}
				/>
			</Grid>
        </Grid>
    );
};

const mapStateToProps = (state) => {
	return {
		filters: state.record.recordsFilters,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setAlbumsFilters: (params) => dispatch(setAlbumsFilters(params)),
		setAlbumsPaging: (params) => dispatch(setAlbumsPaging(params)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Filters);
